module.exports = __webpack_public_path__ + "static/gatsby-icon-3d1e999b3d78bc104f6f0675ad0a9d76.png";